import type { PlaylistId } from 'types/playlist'
import type { GetState } from 'types/redux'
import api from '@disco/api/server'
import {
  PLAYLIST_LOAD_STATS,
  PLAYLIST_LOAD_STATS_ERROR,
  PLAYLIST_LOAD_STATS_SUCCESS,
} from '@disco/constants/ActionTypes'
/**
 * Loads statistics for a specific playlist from the server.
 * Handles both existing playlists in state and fetches playlist versions if needed.
 * @param playlistId - The ID of the playlist to load stats for
 * @returns Thunk that fetches and dispatches playlist statistics
 */
export function loadPlaylistStats(
  playlistId: PlaylistId,
): (dispatch: any, getState: GetState) => Promise<void> {
  return async (dispatch: (...args: Array<any>) => any, getState: GetState) => {
    dispatch({
      type: PLAYLIST_LOAD_STATS,
      playlistId,
    })
    const { playlists } = getState()

    try {
      let playlistVersionId
      const existingPlaylist = playlists[playlistId]

      if (existingPlaylist) {
        playlistVersionId = existingPlaylist.id
      } else {
        const playlist = await api.getPlaylistVersionsByPlaylistId(playlistId)
        if (!playlist?.versions || playlist.versions.length === 0)
          throw new Error('Playlist not found')
        playlistVersionId = playlist.versions[0].id
      }

      const result = await api.getPlaylistStats(playlistVersionId)
      dispatch({
        type: PLAYLIST_LOAD_STATS_SUCCESS,
        playlistId,
        playlist: result,
      })
    } catch (error) {
      dispatch({
        type: PLAYLIST_LOAD_STATS_ERROR,
        playlistId,
        error,
      })
      throw error
    }
  }
}
